module.exports = __webpack_public_path__ + "media/images/donation/credit-card-ff6b1141429ff682b9b3a88e1c511e93.png";